//GENERAL REQUEST
export const POST_REQUEST_PENDING = "POST_REQUEST_PENDING";
export const POST_REQUEST_FAILURE = "POST_REQUEST_FAILURE";

//GET POST
export const GET_POST_REQUEST_SUCCESS = "GET_POST_REQUEST_SUCCESS";

//POST POST
export const POST_POST_REQUEST_SUCCESS = "POST_POST_REQUEST_SUCCESS";

//PATCH POST
export const PATCH_POST_REQUEST_SUCCESS = "PATCH_POST_REQUEST_SUCCESS";

//DELETE POST
export const DELETE_POST_REQUEST_SUCCESS = "DELETE_POST_REQUEST_SUCCESS";
